import * as React from "react";
import { useState } from "react";
import InsuranceInfoStatus from "../commons/model/InsuranceInfoStatus";
import sfetch from "../commons/utils/super-fetch";
import AsyncAction from "../AsyncAction";
import "./PatientInsuranceInfoStatusManager.scss";
import { Success } from "../commons/components/Alerts";

export default function PatientInsuranceInfoStatusManager({
  status,
  patientInsuranceInfoUpdateURL,
}: {
  status: InsuranceInfoStatus;
  patientInsuranceInfoUpdateURL: string;
}) {
  const [dynamicStatus, setDynamicStatus] = useState<InsuranceInfoStatus>(status);
  const label = i18n["Global.Status.processed_on_external_system"];

  switch (dynamicStatus) {
    case InsuranceInfoStatus.UPDATED:
      return (
        <div className="h-flex centered">
          <AsyncAction
            buttonType="button-secondary small"
            promise={async () => sfetch(patientInsuranceInfoUpdateURL, { method: "PUT" })}
            onSuccess={() => setDynamicStatus(InsuranceInfoStatus.PROCESSED)}
            buttonLabel={label}
          />
        </div>
      );
    case InsuranceInfoStatus.PROCESSED:
      return (
        <div className="insurance-info-processed h-flex centered">
          <Success>{label}</Success>
        </div>
      );
    case InsuranceInfoStatus.NOT_STARTED:
    case InsuranceInfoStatus.NO_INSURANCE:
      return null;
  }
}
